import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

class CharactersComponent extends Component {

  render() {
    return (
      <div className="container">
      	<Grid>
      		<Row>
      			<Col xs={12} md={12}>
              Coming soon...
      			</Col>
      		</Row>
      	</Grid>
      </div>
    );
  }
}

export default CharactersComponent;


// WEBPACK FOOTER //
// ./src/components/Characters.js